export const runbookServerConstants = {
  GET_ALL_REQUEST: "GET_ALL_RUNBOOKSERVER_REQUEST",
  GET_ALL_SUCCESS: "GET_ALL_RUNBOOKSERVER_SUCCESS",
  GET_ALL_FAILURE: "GET_ALL_RUNBOOKSERVER_FAILURE",

  GET_REQUEST: "GET_RUNBOOKSERVER_REQUEST",
  GET_SUCCESS: "GET_RUNBOOKSERVER_SUCCESS",
  GET_FAILURE: "GET_RUNBOOKSERVER_FAILURE",

  GET_BY_ID_REQUEST: "GET_RUNBOOKSERVER_BY_ID_REQUEST",
  GET_BY_ID_SUCCESS: "GET_RUNBOOKSERVER_BY_ID_SUCCESS",
  GET_BY_ID_FAILURE: "GET_RUNBOOKSERVER_BY_ID_FAILURE",

  CREATE_REQUEST: "CREATE_RUNBOOKSERVER_REQUEST",
  CREATE_SUCCESS: "CREATE_RUNBOOKSERVER_SUCCESS",
  CREATE_FAILURE: "CREATE_RUNBOOKSERVER_FAILURE",

  UPDATE_REQUEST: "UPDATE_RUNBOOKSERVER_REQUEST",
  UPDATE_SUCCESS: "UPDATE_RUNBOOKSERVER_SUCCESS",
  UPDATE_FAILURE: "UPDATE_RUNBOOKSERVER_FAILURE",

  DELETE_REQUEST: "DELETE_RUNBOOKSERVER_REQUEST",
  DELETE_SUCCESS: "DELETE_RUNBOOKSERVER_SUCCESS",
  DELETE_FAILURE: "DELETE_RUNBOOKSERVER_FAILURE",
};
